/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, InputAdornment, Tooltip, Grid, Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import Chip from '@material-ui/core/Chip';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AlertDialog } from './../../Common/AlertDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchNotFound from '../../../SearchNotFound';
import { LoadingComponent } from 'src/pages/pageLoader';
import Box from '@mui/material/Box';
import _ from 'lodash';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

var screenCode = "PRICEORDERUPDATE"

const useStyles = makeStyles({
  table: {
    minWidth: 1000
  }
});

export default function PriceOrderUpdate(props) {
  const componentRef = useRef();
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [PriceData, setPriceData] = useState([]);
  const [PriceDataOne, setPriceDataOne] = useState([]);
  const [OrginalPriceList, setOrginalPriceList] = useState([]);
  const [MarketData, setMarketData] = useState([]);
  const [RejectedData, setRejectedData] = useState([]);
  const [ProposedPopUp, setProposedPopUp] = useState();
  const [ApprovePopUp, setApprovePopUp] = useState();
  const [RealizedPopUp, setRealizedPopUp] = useState();
  const [message, setMessage] = useState("Confirmation Proposed Price");
  const [messageApproved, setmessageApproved] = useState("Confirmation Approve");
  const [messageRealized, setmessageRealized] = useState("Confirmation Realized Price");
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [EnableConfirmMessageApprove, setEnableConfirmMessageApprove] = useState(false);
  const [EnableConfirmMessageRealized, setEnableConfirmMessageRealized] = useState(false);
  const [Datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));
  const [openDialog, setOpenDialog] = React.useState(false);
  const [RejectData, setRejectData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [OpenRejectList, setOpenRejectList] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [updateRealized, setUpdateRealized] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const { productID } = useParams();
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    submitButtonName: 'Update',
    pageheadername: 'Daily Price Update'
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isTimeChecked: false,
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    date: new Date().toISOString().split('T')[0],
  });
  const classes = useStyles();

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: '',
    operationEntityID: '',
    date: ''
  });

  const priceOrderUpdateSearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number()
      .min(1, 'Please Select Fresh Collection Center')
      .required('Fresh Collection Center required'),
    date: Yup.date().required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      date: formData.date,
    },

    validationSchema: priceOrderUpdateSearchSchema,
    onSubmit: (values) => {
    }
  });
  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  useEffect(() => {
    trackPromise(getPermissions());
  }, [])

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    setPriceData([])
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setPriceData([])
  }, [formik.values.date]);

  async function clearAll() {
    setPriceData([]);
    formik.resetForm();
    setValues({
      ...values,
      operationEntityID: 0,
      date: new Date().toISOString().split('T')[0],
    })
  }

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRICEORDERUPDATE');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isTimeChecked = permissions.find(p => p.permissionCode == 'TIMECHECKPRICEORDERUPDATE');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isTimeChecked: isTimeChecked !== undefined,
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(GetAllGroups());
  }

  async function SearchData() {
    let model = {
      operationEntityID: parseInt(values.operationEntityID),
      date: formik.values.date
    };
    const originalDate = new Date(formik.values.date)
    const modifiedDate = new Date(originalDate.getTime() - (24 * 60 * 60 * 1000));
    const res = await services.GetPerformOrderDetailsForMainOrder(modifiedDate.toISOString());

    setIsDisabled(res.performOrder.length == 0 ? false : true)
    const result = await services.GetAllDailyPriceUpdate(model);
    var ress2 = res.performOrder.find(x => x.statusID == 2)
    let foundOne = result.filter(x => x.quantity != 0 || x.proposedQuantity != 0);
    let found = [];
    if (ress2) {
      found = foundOne.filter(x => x.proposedPrice != 0);
    } else {
      found = foundOne;
    }
    const resultTwo = await services.GetMappedMarketPrice(parseInt(values.operationEntityID), formik.values.date);
    const resultThree = await services.CheckWeighmentDoneFromPerformOrder(parseInt(values.operationEntityID), formik.values.date);
    found.forEach(x => {
      let find = resultTwo.find(y => y.productID == x.cropID)
      let findOne = resultThree.find(y => y.productID == x.cropID)
      if (find) {
        let latestRow = find.priceModel.reduce((a, b) => {
          return new Date(a.date) > new Date(b.date) ? a : b;
        });
        x.minPrice = latestRow.priceMin;
        x.maxPrice = latestRow.priceMax;
        x.date = latestRow.date;
      }
      else {
        x.minPrice = '-'
        x.maxPrice = '-'
        x.date = '-';
      }
      if (findOne) {
        x.isWeighmentDone = true
      }
      else {
        x.isWeighmentDone = false
      }
    })
    setPriceData(found);
    const object = _.cloneDeep(result);
    const objectOne = _.cloneDeep(found);
    setPriceDataOne(objectOne);
    setOrginalPriceList(object);
    getSelectedDropdownValuesForReport();
  }

  async function SaveDailyPriceUpdateDetails() {
    const found = PriceData.filter(x => x.proposedPrice > 0);
    const newResult = createUpdateList(found, PriceDataOne)
    newResult.forEach(x => {
      x.operationEntityID = parseInt(formik.values.operationEntityID);
      x.operationEntityName = selectedSearchValues.operationEntityID;
      x.createdBy = parseInt(TokenDecoder.getUserIDFromToken());
      x.priceProposedDate = formik.values.date;
      x.secondProposedPrice = x.secondProposedPrice == NaN || x.secondProposedPrice == "" ? 0 : x.secondProposedPrice;
      x.isTimeChecked = permissionList.isTimeChecked;
    });
    var res = await services.SaveDailyPriceUpdateDetails(newResult);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      setIsUpdate(false)
      trackPromise(SearchData(formik.values));
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } else {
      toast.error(res.message);
      trackPromise(SearchData(formik.values));
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }

  function createUpdateList(newRes, oldRes) {
    const changedObjects = newRes.filter(newObj => {
      const matchingOldObj = oldRes.find(oldObj => oldObj.secondProposedPrice === newObj.secondProposedPrice);
      return !_.isEqual(newObj, matchingOldObj);
    });
    return changedObjects
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  function generateGroupForDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.groupID} value={x.groupID}>{x.groupName}</MenuItem>)
      });
    }
    return items
  }

  function generateOperationEntityForDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        x.factoryType == 2 ? items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>) :
          null
      });
    }
    return items
  }

  function changeText(e, index) {
    setIsUpdate(true)
    const target = e.target;
    const value = target.value
    const newArr = [...PriceData];
    const valueTwo = value == "" ? null : parseFloat(value)

    newArr[index] = { ...newArr[index], proposedPrice: parseFloat(valueTwo) };
    setPriceData(newArr)
  }

  function changeTextTwo(e, index) {
    setIsUpdate(true)
    const target = e.target;
    const value = target.value
    const newArr = [...PriceData];
    const valueTwo = value == "" ? parseFloat(0) : parseFloat(value)

    newArr[index] = { ...newArr[index], secondProposedPrice: parseFloat(valueTwo) };
    setPriceData(newArr)
  }

  function changeTextRelized(e, index) {
    setIsUpdate(true)
    setUpdateRealized(true)
    const target = e.target;
    const value = target.value
    const newArr = [...PriceData];
    const valueTwo = value == "" ? null : parseFloat(value)
    const createdBy = parseInt(TokenDecoder.getUserIDFromToken());

    newArr[index] = { ...newArr[index], realizedPrice: parseFloat(valueTwo), createdBy: createdBy };
    setPriceData(newArr)

  }

  async function handleApprove(value) {
    let model = {
      productPriceID: parseInt(value.productPriceID),
      approvedPrice: parseFloat(value.approvedPrice),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      operationEntityName: selectedSearchValues.operationEntityID,
      productName: value.productName,
      realizedPriceStatus: parseInt(1)
    };
    var res = await services.ApproveDailyPriceUpdateDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
    } else {
      toast.error(res.message);
    }
  }

  async function handleRealizePriceUpdate(value) {
    const newArray2 = PriceData.map((item) => {
      const match = OrginalPriceList.find((el) => el.productPriceID === item.productPriceID && el.realizedPrice !== item.realizedPrice);
      if (match !== undefined) {
        return { ...item, previousRealizedPrice: match.realizedPrice, xd: true };
      } else {
        return { ...item, isRealizedEdited: false, xd: false };
      }
    });

    const newArray3 = newArray2.map((item) => {
      if (item.realizedPriceStatus == 3 && item.previousRealizedPrice > item.initialRealizedPrice) {
        if (item.realizedPrice > item.previousRealizedPrice && item.xd == true) {
          return { ...item, isRealizedEdited: true, realizedPriceStatus: 2 };
        }
        else if (item.realizedPrice < item.previousRealizedPrice && item.xd == true) {
          return { ...item, isRealizedEdited: false, realizedPriceStatus: 1 };
        }
        else if (item.realizedPrice == item.previousRealizedPrice && item.xd == true) {
          return { ...item, isRealizedEdited: false, realizedPriceStatus: item.realizedPriceStatus };
        }
        else {
          if (item.realizedPrice == item.previousRealizedPrice) {
            return { ...item, isRealizedEdited: false, realizedPriceStatus: item.realizedPriceStatus };
          }
          return { ...item, isRealizedEdited: true, realizedPriceStatus: item.realizedPriceStatus };
        }
      }
      if (item.realizedPrice > item.initialRealizedPrice && item.xd == true) {
        return { ...item, isRealizedEdited: true, realizedPriceStatus: 2 };
      }
      else if (item.realizedPrice < item.initialRealizedPrice && item.xd == true) {
        return { ...item, isRealizedEdited: false, realizedPriceStatus: 1 };
      }
      else {
        if (item.realizedPriceStatus === 2) {
          if (item.realizedPrice == item.initialRealizedPrice) {
            return { ...item, isRealizedEdited: false, realizedPriceStatus: item.realizedPriceStatus };
          }
          return { ...item, isRealizedEdited: true, realizedPriceStatus: item.realizedPriceStatus };
        }
        return { ...item, isRealizedEdited: false, realizedPriceStatus: item.realizedPriceStatus };
      }
    });

    const filteredData = newArray3.filter(item => item.realizedPrice > 0);

    filteredData.forEach(x => {
      x.operationEntityName = selectedSearchValues.operationEntityID;
    });
    var res = await services.RealizedPriceUpdateDetails(filteredData);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setIsUpdate(false);
      setUpdateRealized(false);
    } else {
      toast.error(res.message);
    }
  }

  async function handleReject() {
    let model = {
      productPriceID: parseInt(RejectData.productPriceID),
      createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
      operationEntityID: parseInt(formik.values.operationEntityID),
      operationEntityName: selectedSearchValues.operationEntityID,
      cropID: parseInt(RejectData.cropID),
      productName: RejectData.productName,
      quantity: parseInt(RejectData.quantity),
      proposedPrice: parseInt(RejectData.proposedPrice),
      secondProposedPrice: parseInt(RejectData.secondProposedPrice),
      approvedPrice: parseInt(RejectData.approvedPrice),
      priceProposedDate: formik.values.date,
      reason: formik.values.reason
    };
    var res = await services.RejectDailyPriceUpdateDetails(model);
    if (res.statusCode === "Success") {
      toast.success(res.message);
      trackPromise(SearchData(formik.values));
      setOpenDialog(false);
    } else {
      toast.error(res.message);
    }
  }

  async function handleHartiPriceView(value) {
    let model = {
      cropID: parseInt(value.cropID),
      date: formik.values.date
    };
    var res = await services.GetMarketPriceDetails(model);
    if (res != null) {
      setMarketData(res)
    }
    setOpen(true)
  }

  async function handleRejectDetalisList() {
    let model = {
      operationEntityID: parseInt(formik.values.operationEntityID),
      priceProposedDate: formik.values.date
    };
    var res = await services.GetAllRejectPriceDetails(model);
    if (res != null) {
      setRejectedData(res)
    }
    setOpenRejectList(true)
  }

  function confirmData(y) {
    if (y) {
      SaveDailyPriceUpdateDetails(ProposedPopUp);
    }
  }

  async function createFile() {
    var file = await createDataForExcel(PriceData);
    var settings = {
      sheetName: 'Daily Price Update',
      fileName: 'Daily Price Update - ' + selectedSearchValues.date,
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Daily Price Update',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Product': x.productName,
          'Qty(Kg)': x.proposedQuantity.toFixed(2),
          'PP(Rs)': x.proposedPrice.toFixed(2),
          'AP(Rs)': x.approvedPrice.toFixed(2),
          '2nd PP(Rs)': x.secondProposedPrice.toFixed(2),
          'RP(Rs)': x.realizedPrice.toFixed(2),
          '2nd PP Status': x.secondProposedPriceStatus == 0 ? 'Not Set' : x.secondProposedPriceStatus == 1 ? 'Pending' : x.secondProposedPriceStatus == 2 ? 'Approved' : x.secondProposedPriceStatus == 3 ? 'Rejected' : '',
          'Status': x.status == 0 ? 'New' : x.status == 1 ? 'Pending' : x.status == 2 ? 'Pending' : x.status == 3 ? 'Approved' : x.status == 4 ? 'Rejected' : '',
          'Realized Price Status': x.realizedPriceStatus == 0 ? 'Not Set' : x.realizedPriceStatus == 1 ? 'New' : x.realizedPriceStatus == 2 ? 'Pending' : x.realizedPriceStatus == 3 ? 'Approved' : x.realizedPriceStatus == 4 ? 'Rejected' : '',
          'Harti Price Last Updated Date': x.date ? x.date.split('T')[0] : '',
          'Min(Rs)': typeof x.minPrice === 'number' ? x.minPrice.toFixed(2) : '',
          'Max(Rs)': typeof x.maxPrice === 'number' ? x.maxPrice.toFixed(2) : '',
        };
        res.push(vr);
      });

      res.push({});

      var vr1 = {
        'Product': "Group: " + selectedSearchValues.groupID,
        'Qty(Kg)': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
        'PP(Rs)': "Date: " + selectedSearchValues.date
      }
      res.push(vr1);
    }
    return res;
  }

  function getSelectedDropdownValuesForReport() {
    let groupData = groupList.find(x => x.groupID == formik.values.groupID);

    let collection =
      formik.values.operationEntityID === 0
        ? ''
        : operationEntityList.find(x => x.factoryID === formik.values.operationEntityID);

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupID: groupData ? groupData.groupName : '',
      operationEntityID: collection ? collection.factoryName : 'All Fresh Collection Centers',
      date: formik.values.date.split('T')[0]
    });
  }

  async function confirmMessage(data) {
    setIsLoading(true);
    setEnableConfirmMessage(true);
    setProposedPopUp(data)

  }

  function confirmApproved(y) {
    if (y) {
      trackPromise(handleApprove(ApprovePopUp));
    }
  }

  function confirmRealized(y) {
    if (y) {
      trackPromise(handleRealizePriceUpdate(RealizedPopUp));
    }
  }

  async function confirmMessageRealized(data) {
    setEnableConfirmMessageRealized(true);
    setRealizedPopUp(data)
  }

  async function confirmMessageApprove(data) {
    setEnableConfirmMessageApprove(true);
    setApprovePopUp(data);
  }

  const handleClose = () => {
    setOpenDialog(false);
    setOpen(false);
    setOpenRejectList(false);
  };

  async function RejectPopUpFunc(data) {
    setOpenDialog(true);
    setRejectData(data);
  }

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }
  var date = new Date();
  return (
    <>
      <LoadingComponent />
      <Page title="Daily Price Update  |  FAPS">
        <Container maxWidth>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Group</MenuItem>
                    {generateGroupForDropDownMenu(groupList)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                    {generateOperationEntityForDropDownMenu(operationEntityList)}
                  </TextField>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      size="small"
                      label="Date *"
                      openTo="day"
                      type="Date"
                      maxDate={new Date().setDate(new Date().getDate() + 6)}
                      views={['year', 'month', 'day']}
                      value={Datevalue}
                      onChange={(newValue) => {
                        setDateValue(newValue);
                      }}
                      renderInput={(params) =>
                        <TextField
                          fullWidth
                          size="small"
                          {...params}
                        />}
                    />
                  </LocalizationProvider> */}
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    name='date'
                    size="small"
                    label="Date *"
                    type='date'
                    variant="outlined"
                    onKeyDown={onKeyDown}
                    onChange={formik.handleChange}
                    {...getFieldProps('date')}
                    error={Boolean(touched.date && errors.date)}
                    helperText={touched.date && errors.date}
                    value={formik.values.date}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      min: new Date().toISOString().split('T')[0],
                      max: date.addDays(6).toISOString().split('T')[0]
                    }}
                  />
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
                    {PriceData.length != 0 ?
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="right" >
                        <Chip label="Reject Price Details" variant="filled" onClick={handleRejectDetalisList} />
                      </Stack> : null}
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Button
                      type="button"
                      variant="outlined"
                      color="error"
                      onClick={() => clearAll()}
                    >
                      Clear
                    </Button>
                    <Button
                      type="submit"
                      color="secondary"
                      variant="outlined"
                      onClick={() => trackPromise(SearchData())}                >
                      Search
                    </Button>
                  </Stack>
                </Stack>
                <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                  <DialogTitle id="form-dialog-title">{"Harti Price List"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Container>
                        {MarketData.length > 0 && (
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Typography variant="h7" gutterBottom>
                              Applicable Date: {MarketData[0].date.split('T')[0]}
                            </Typography>
                          </Stack>
                        )}
                        <Card style={{ justifycontent: 'center', width: '31rem' }}>
                          <Paper className={classes.root}>
                            <TableContainer component={Paper}>
                              <Table aria-label="collapsible table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 'bold' }}>Market Name</TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Min Price(Rs)</TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>Max Price(Rs)</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {MarketData.map((row, i) => {
                                    return (
                                      <TableRow key={i}>
                                        <TableCell component="th" scope="row" align="left"> {row.marketName}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.priceMin}</TableCell>
                                        <TableCell component="th" scope="row" align="right"> {row.priceMax}</TableCell>
                                      </TableRow>
                                    )
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </Card>
                        <DialogActions>
                          <Button onClick={handleClose} color="secondary">
                            CANCEL
                          </Button>
                        </DialogActions>
                      </Container>
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
                <Dialog fullWidth={true} open={OpenRejectList} aria-labelledby="form-dialog-title" maxWidth='lg'>
                  <DialogTitle id="form-dialog-title">{"Rejected Price List"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      <Container>
                        <Card style={{ justifycontent: 'center' }}>
                          <Paper className={classes.root}>
                            <TableContainer component={Paper}>
                              <Table aria-label="collapsible table">
                                <TableHead>-
                                  <TableRow>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Date</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Fresh Collection Center</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Product Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Proposed Price</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Reorder Price</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Approved Price</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Reason</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {RejectedData.map((row, i) => {
                                    return (
                                      <TableRow key={i}>
                                        <TableCell component="th" scope="row" align="center"> {row.priceProposedDate.split(' ')[0]}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.factoryName}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.productName}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {parseFloat(row.quantity).toFixed(2)}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {parseFloat(row.proposedPrice).toFixed(2)}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {parseFloat(row.secondProposedPrice).toFixed(2)}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {parseFloat(row.approvedPrice).toFixed(2)}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.reason}</TableCell>
                                      </TableRow>
                                    )
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </Card>
                        <DialogActions>
                          <Button onClick={handleClose} color="secondary">
                            CANCEL
                          </Button>
                        </DialogActions>
                      </Container>
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
                <div hidden={true}>
                  <Grid item>
                    <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                      discription={"Are you sure want to add proposed price ?"} setViewPopup={setEnableConfirmMessage} />
                  </Grid>
                </div>
                <div hidden={true}>
                  <Grid item>
                    <AlertDialog confirmData={confirmApproved} headerMessage={messageApproved} viewPopup={EnableConfirmMessageApprove}
                      discription={"Are you sure want to approve approved price ?"} setViewPopup={setEnableConfirmMessageApprove} />
                  </Grid>
                </div>
                <div hidden={true}>
                  <Grid item>
                    <AlertDialog confirmData={confirmRealized} headerMessage={messageRealized} viewPopup={EnableConfirmMessageRealized}
                      discription={"Are you sure want to update Realized Price ?"} setViewPopup={setEnableConfirmMessageRealized} />
                  </Grid>
                </div>
                <Dialog open={openDialog} onClose={handleClose} fullWidth={true}
                  aria-labelledby="form-dialog-title">
                  <DialogTitle id="form-dialog-title">Reason</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      To Reject, Please Provide a Reason
                    </DialogContentText>
                    <br />
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      size="small"
                      label="Reason *"
                      variant="outlined"
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                      {...getFieldProps('reason')}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      color="secondary"
                      type="button"
                      variant="outlined"
                      onClick={handleClose}>Cancel</Button>
                    <Button
                      color="secondary"
                      id="btnCancel"
                      variant="contained"
                      disabled={formik.values.reason == null || formik.values.reason == "" ? true : false}
                      className={
                        classes.colorCancel
                      }
                      onClick={() => handleReject()} >Reject</Button>
                  </DialogActions>
                </Dialog>
                <br />
                <>
                  {PriceData.length != 0 ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TableContainer sx={{ maxHeight: 440 }}>
                        <Table size="small" border='1px' stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Product</TableCell>
                              <TableCell align="center">Qty(Kg)</TableCell>
                              <TableCell align="center">PP(Rs)</TableCell>
                              <TableCell align="center">AP(Rs) </TableCell>
                              <TableCell align="center">Reorder Price(Rs)</TableCell>
                              <TableCell align="center">RP(Rs) </TableCell>
                              <TableCell align="center">Reorder Price Status</TableCell>
                              <TableCell align="center">Status</TableCell>
                              <TableCell align="center">Realized Price Status</TableCell>
                              <TableCell align="center">Harti Price<br></br>Last Updated Date</TableCell>
                              <TableCell align="center">Min(Rs)	 </TableCell>
                              <TableCell align="center">Max(Rs) </TableCell>
                              <TableCell align="center">Harti Price </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {PriceData.map((row, i) => {
                              return (
                                <TableRow key={i}>
                                  <TableCell align="left">{row.productName}</TableCell>
                                  <TableCell align="right">{row.proposedQuantity == 0 ? parseFloat(row.quantity).toFixed(2) : parseFloat(row.proposedQuantity).toFixed(2)}</TableCell>
                                  <TableCell align="right" width={130}>
                                    {isDisabled == true && row.status != 0 ?
                                      parseFloat(row.proposedPrice).toFixed(2) :
                                      <TextField
                                        size="small"
                                        id="outlined-size-small"
                                        name="proposedPrice"
                                        defaultValue={0}
                                        onKeyDown={(evt) =>
                                          (evt.key === "-") && evt.preventDefault()
                                        }
                                        InputProps={{
                                          inputProps: {
                                            step: 0.01,
                                            type: 'number',
                                            style: {
                                              textAlign: 'right',
                                            },
                                          },
                                        }}
                                        onWheel={event => event.target.blur()}
                                        onChange={(e) => changeText(e, i)}
                                        value={row.proposedPrice}
                                      />
                                    }
                                  </TableCell>
                                  <TableCell align='right' >
                                    {row.status == 2 ?
                                      <div style={{ display: 'flex' }}>
                                        {row.approvedPrice != 0 ?
                                          <Chip label={row.approvedPrice} variant="outlined" color='success' />
                                          : '-'}
                                        {/* -------Removed Reject action as per the requirement, Keeping this code block for future use if needed
                                        {row.approvedPrice != 0 ?
                                          <Tooltip title="Reject">
                                            <IconButton aria-label="delete" onClick={() => RejectPopUpFunc(row)}>
                                              <CloseIcon />
                                            </IconButton>
                                          </Tooltip> 
                                          : null} */}
                                        {row.approvedPrice != 0 ?
                                          <Tooltip title="Approve">
                                            <IconButton aria-label="delete" onClick={() => confirmMessageApprove(row)}>
                                              <CheckIcon />
                                            </IconButton>
                                          </Tooltip> : null}
                                      </div>
                                      : row.approvedPrice == 0 ? '-' : parseFloat(row.approvedPrice).toFixed(2)}
                                  </TableCell>
                                  <TableCell align="right" width={130}>
                                    {row.status == 0 ?
                                      '-' :
                                      <TextField
                                        size="small"
                                        id="outlined-size-small"
                                        name="secondProposedPrice"
                                        //defaultValue={0}
                                        onKeyDown={(evt) =>
                                          (evt.key === "-") && evt.preventDefault()
                                        }
                                        InputProps={{
                                          inputProps: {
                                            step: 0.01,
                                            type: 'number',
                                            style: {
                                              textAlign: 'right',
                                            },
                                          },
                                          disabled: row.status == 2 ? true : false,
                                          endAdornment: row.secondProposedPrice == 0 ? <InputAdornment position="end">-</InputAdornment> : null
                                        }}
                                        onWheel={event => event.target.blur()}
                                        onChange={(e) => changeTextTwo(e, i)}
                                        value={row.secondProposedPrice == 0 ? "" : row.secondProposedPrice}
                                      />}
                                  </TableCell>
                                  {row.status != 3 ?
                                    <TableCell align="right">{row.realizedPrice == 0 ? '-' : parseFloat(row.realizedPrice).toFixed(2)}</TableCell> :
                                    row.isWeighmentDone == true ?
                                      <TableCell align="right" >
                                        {row.realizedPrice == 0 ? '-' : parseFloat(row.realizedPrice).toFixed(2)}
                                      </TableCell> :
                                      <TableCell align="center" width={130}>
                                        <TextField
                                          size="small"
                                          id="outlined-size-small"
                                          name="realizedPrice"
                                          defaultValue={0}
                                          onKeyDown={(evt) =>
                                            (evt.key === "-") && evt.preventDefault()
                                          }
                                          InputProps={{
                                            inputProps: {
                                              step: 0.01,
                                              type: 'number',
                                              style: {
                                                textAlign: 'right',
                                              },
                                            },
                                          }}
                                          onWheel={event => event.target.blur()}
                                          onChange={(e) => changeTextRelized(e, i)}
                                          value={row.realizedPrice}
                                        />
                                      </TableCell>}
                                  <TableCell align="center">
                                    {row.secondProposedPriceStatus == 0 ?
                                      <Chip label="Not Set" variant="outlined" />
                                      : null}
                                    {row.secondProposedPriceStatus == 1 ?
                                      <Chip label="Pending" variant="outlined" />
                                      : null}
                                    {row.secondProposedPriceStatus == 2 ?
                                      <Chip label="Approved" color="primary" />
                                      : null}
                                    {row.secondProposedPriceStatus == 3 ?
                                      <Chip label="Rejected" color="error" />
                                      : null}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.status == 4 ?
                                      <Chip label="Rejected" color="error" />
                                      : null}
                                    {row.status == 3 ?
                                      <Chip label="Approved" color="primary" />
                                      : null}
                                    {row.status == 1 ?
                                      <Chip label="Pending" variant="outlined" />
                                      : null}
                                    {row.status == 2 ?
                                      <Chip label="Pending" variant="outlined" />
                                      : null}
                                    {row.status == 0 ?
                                      <Chip label="New" variant="outlined" />
                                      : null}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.realizedPriceStatus == 4 ?
                                      <Chip label="Rejected" color="error" />
                                      : null}
                                    {row.realizedPriceStatus == 3 ?
                                      <Chip label="Approved" color="primary" />
                                      : null}
                                    {row.realizedPriceStatus == 1 ?
                                      <Chip label="New" variant="outlined" />
                                      : null}
                                    {row.realizedPriceStatus == 2 ?
                                      <Chip label="Pending" variant="outlined" />
                                      : null}
                                    {row.realizedPriceStatus == 0 ?
                                      <Chip label="Not Set" variant="outlined" />
                                      : null}
                                  </TableCell>
                                  <TableCell align="center">{row.date === '-' ? '-' : new Date(row.date).toLocaleDateString('en-US')}</TableCell>
                                  <TableCell align="right">{row.minPrice == '-' ? '-' : parseFloat(row.minPrice).toFixed(2)}</TableCell>
                                  <TableCell align="right">{row.maxPrice == '-' ? '-' : parseFloat(row.maxPrice).toFixed(2)}</TableCell>
                                  <TableCell align="center">
                                    <IconButton aria-label="delete" onClick={() => trackPromise(handleHartiPriceView(row))}>
                                      <VisibilityIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {/* </Card> */}
                    </Stack> : <SearchNotFound searchQuery="Daily Price Update" />}
                  {PriceData.length != 0 ?
                    <Divider variant="middle" /> : null}
                  {PriceData.length != 0 ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorRecord}
                          onClick={() => createFile()}
                        >
                          EXCEL
                        </Button>
                        <ReactToPrint
                          documentTitle={"Daily Price Update Report"}
                          trigger={() => <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem', backgroundColor: 'red' }}
                            onClick={() => getSelectedDropdownValuesForReport()}
                          >
                            PDF
                          </Button>}
                          content={() => componentRef.current}
                        />
                        {updateRealized == false ?
                          <LoadingButton
                            size="small"
                            type="button"
                            onClick={() => confirmMessage()}
                            color="secondary"
                            loading={isLoading}
                            variant="outlined"
                            disabled={isUpdate == false}
                          >
                            {pageProps.submitButtonName}
                          </LoadingButton> :
                          <LoadingButton
                            size="small"
                            type="button"
                            onClick={() => confirmMessageRealized()}
                            color="secondary"
                            loading={isLoading}
                            variant="outlined"
                            disabled={isUpdate == false}
                          >
                            {pageProps.submitButtonName}
                          </LoadingButton>}
                        <div hidden={true}>
                          <CreatePDF ref={componentRef}
                            tableData={PriceData} searchData={selectedSearchValues}
                          />
                        </div>
                      </Box>
                    </Stack> : null}
                </>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  );
}
